var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalEchec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2468_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4714 10.5384C47.4333 -3.49978 24.5842 -3.49978 10.546 10.5384C3.74586 17.3412 0 26.3839 0 36.001C0 45.6182 3.74586 54.6609 10.546 61.461C17.5665 68.4815 26.7876 71.9903 36.0086 71.9903C45.2297 71.9903 54.451 68.4815 61.4713 61.461C75.5095 47.4229 75.5095 24.5792 61.4714 10.5384ZM57.5274 57.517C45.6621 69.3824 26.3552 69.3824 14.4899 57.517C8.74415 51.7713 5.57837 44.1288 5.57837 36.001C5.57837 27.8733 8.74415 20.2308 14.4899 14.4823C26.3552 2.61691 45.6621 2.61972 57.5274 14.4823C69.39 26.3476 69.39 45.6545 57.5274 57.517Z",
    fill: "#19295C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0274 43.7112L40.1311 35.8261L48.0274 27.9411C49.1152 26.8533 49.1152 25.0878 48.0302 23.9971C46.9397 22.9037 45.1741 22.9065 44.0836 23.9942L36.1818 31.8849L28.28 23.9942C27.1894 22.9065 25.4238 22.9037 24.3333 23.9971C23.2455 25.0876 23.2455 26.8532 24.3361 27.9411L32.2324 35.8261L24.3361 43.7112C23.2455 44.7989 23.2455 46.5645 24.3333 47.6552C24.8772 48.2018 25.594 48.4724 26.3081 48.4724C27.0222 48.4724 27.7362 48.199 28.2801 47.6579L36.1819 39.7672L44.0837 47.6579C44.6276 48.2018 45.3416 48.4724 46.0557 48.4724C46.7698 48.4724 47.4866 48.199 48.0305 47.6552C49.118 46.5645 49.118 44.7989 48.0274 43.7112Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2468_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalEchec);
export default __webpack_public_path__ + "static/media/ModalEchec.11d7ae173428920423eb1164916bf119.svg";
export { ForwardRef as ReactComponent };